import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../Styles/menu.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {faBars,faXmark} from "@fortawesome/free-solid-svg-icons";
import { UserContext } from "../context/UserProvider";



function Menu() {
  const { user, signOutUser } = useContext(UserContext);

  const [show, handleShow] = useState(false);
  const navigate = useNavigate();
  const transitionNavBar = () => {
    if (window.scrollY > 100) {
      handleShow(true);
    } else {
      handleShow(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", transitionNavBar);
    return () => window.removeEventListener("scroll", transitionNavBar);
  }, []);

  const [menu, setMenu] = useState(false);
  const displayMenu = () => {
    setMenu(!menu);
  };

  const handleClickLogout = async () => {
    try {
      await signOutUser();
    } catch (error) {
      console.log(error.code);
    }
  };

  return (
    <>
      <div className={`nav ${show && "nav__black"}`}>
        <div className="nav__contents">
          <img
            onClick={() => navigate("/")}
            className="nav__logo"
            src="https://firebasestorage.googleapis.com/v0/b/miladetallesweb.appspot.com/o/logos%2Flogomini.jpg?alt=media&token=78dd7dc9-1486-49eb-9b57-b3e6ddc953ad"
            alt="logo-mini"
          />
          <i className="eslogan">Los mejores detalles para ti</i>
          <div id="navbarNav">
            <ul className="menu_principal">
              <li className="nav-item">
                <a href="#inicio" onClick={() => navigate("/")}>
                  Inicio
                </a>
                {/* <Link className="" to='/'>Inicio</Link> */}
              </li>
              <li className="nav-item">
                <a href="#productos_categoria" onClick={() => navigate("/#productos_categoria")}>Productos</a>
              </li>

              <li className="nav-item-navi">
                <a 
                  onClick={() => navigate("/productosNavidad")}
                  //href='/productosNavidad'  
                >Navidad</a>
              </li>

              <li className="nav-item">
                <a href="#contactenos" onClick={() => navigate("/#contactenos")}>Contáctenos</a>
              </li>
              {!user ? (
                <>
                  <li className="nav-item">
                    <a  onClick={() => navigate("/login")}>
                      Acceso
                    </a>
                  </li>
                </>
              ) : (
                <>
                  <li className="nav-item">
                    <a onClick={() => navigate("./admin")}>
                      Registro Productos
                    </a>
                  </li>
                  <li className="nav-item">
                    <a href='/' onClick={handleClickLogout}>Logout</a>
                  </li>
                </>
              )}
            </ul>
          </div>
          {!menu ? (
            <div onClick={displayMenu}>
              <i className="otro_Menu fa-solid fa-bars fa-2xl"></i>
            </div>
          ) : (
            <div>
              <div onClick={displayMenu}>
                <i className="otro_Menu fa-solid fa-xmark fa-2xl"></i>
              </div>

              <ul className="menu_principal2">
                <li className="nav-item">
                  <Link className="nav-link" to="/" onClick={displayMenu}>
                    Inicio
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/productos"
                    onClick={displayMenu}
                  >
                    Productos
                  </Link>
                </li>

                <li className="nav-item-navi-movil">
                  <Link
                    className="nav-link"
                    to="/productosNavidad"
                    onClick={displayMenu}
                  >
                    Navidad
                  </Link>
                </li>


                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/#contactenos"
                    onClick={displayMenu}
                  >
                    Contactenos
                  </Link>
                </li>
                {!user ? (
                  <>
                    <li className="nav-item">
                      <Link
                        className="nav-link"
                        to="/login"
                        onClick={displayMenu}
                      >
                        Acceso
                      </Link>
                    </li>
                  </>
                ) : (
                  <>
                    <li className="nav-item">
                      <Link className="nav-link" to="/admin" onClick={displayMenu}>
                        Registro Productos
                      </Link>
                    </li>
                    <li className="nav-item">
                      <a href='/' className="nav-link" onClick={handleClickLogout}>
                        Logout
                      </a>
                    </li>
                  </>
                )}

                <li className="nav-link-rs">
                  <a
                    className="btn btn-outline-dark btn-floating m-1"
                    href="https://www.facebook.com/Miladetallesparaelhogar"
                  >
                    <i className="fa-brands fa-facebook"></i>
                  </a>

                  <a
                    className="btn btn-outline-dark btn-floating m-1"
                    href="https://www.instagram.com/mila_detalles/"
                  >
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                  <a
                    className="btn btn-outline-dark btn-floating m-1"
                    href="https://www.tiktok.com/@miladetalles"
                  >
                    <i className="fa-brands fa-tiktok"></i>
                  </a>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Menu;
